import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { CancelOrderComponent } from 'src/app/layout/orders/specific-order/order-details/order-tabs/order-details-general/order-details-general-admin/cancel/cancel-order.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-order-details-general-admin',
  templateUrl: './order-details-general-admin.component.html',
  styleUrls: ['./order-details-general-admin.component.css']
})
export class OrderDetailsGeneralAdminComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();

  orderOperationsSubscription: Subscription;

  dialogCancelOrderRef: MatDialogRef<CancelOrderComponent>;

  userId: string;

  constructor(public dialog: MatDialog, private ordersService: OrdersService,
    private notificationsService: NotificationsService,
    private keycloakService: KeycloakService) {

  }

  ngOnInit() {
    const keycloakTokenParsed = this.keycloakService.getKeycloakInstance().tokenParsed;
    this.userId = keycloakTokenParsed['preferred_username'];
  }

  public async cancelOrderPopup() {
    this.dialogCancelOrderRef = this.dialog.open(CancelOrderComponent, {
      width: '850px'
    });

    this.dialogCancelOrderRef.afterClosed().subscribe((cancelOrderObject) => {
      if (cancelOrderObject.cancel) {
        this.ordersService.cancelOrder(this.summary.id, cancelOrderObject.comments, this.summary.externalId, this.userId).subscribe(
          (data) => {
            this.notificationsService.showNotification('La orden se ha cancelado correctamente', NotificationLevel.SUCCESS);
            this.cancelOrderEvent.emit();
          },
          (error) => {
            this.notificationsService.showNotification('Ha habido un problema al cancelar la orden', NotificationLevel.ERROR);
          }
        );
      }
    });
  }
}
